import { sendMessage } from "actions";
import { DriverSession } from "lib/deviceDrivers/sessionFramework/runtime/DriverSession";
import { type DriverNotifier } from "lib/deviceDrivers/sessionFramework/adapter/driverEffects";
import { toastNotifier } from "lib/deviceDrivers/sessionFramework/adapter/toastNotifier";
import { createXrs2iDevice } from "lib/deviceDrivers/truTest/xrs2i/device/createProtocol";
import {
  mapDeviceEventToDriverEffects,
  type DriverAction,
  type DriverActionResult,
} from "lib/deviceDrivers/truTest/xrs2i/adapters/driverEffects";
import {
  Xrs2iDeviceHandle,
  Xrs2iEvent,
} from "lib/deviceDrivers/truTest/xrs2i/device/types";

export class Xrs2iDriverSession extends DriverSession<
  Xrs2iDeviceHandle,
  DriverAction,
  Xrs2iEvent
> {
  constructor(deviceId: string, notifier: DriverNotifier = toastNotifier) {
    super(
      deviceId,
      createXrs2iDevice,
      (id, payload) => sendMessage(id, payload),
      mapDeviceEventToDriverEffects,
      notifier,
    );
  }

  readSavedScans(): DriverActionResult {
    void this.device.readSavedScans();
    return this.drainEffects();
  }

  syncState(): DriverActionResult {
    void this.device.resetHardwareConfig();
    return this.drainEffects();
  }

  cancelReadSavedScans(): DriverActionResult {
    this.device.cancelReadSavedScans();
    return this.drainEffects();
  }
}
